export default {
  computed: {
    isDraftButtonDisabled () {
      const post = this.$store.getters['socialPostsCreationPostEditorial/getPost']

      // Vérifier libellé et texte
      const hasRequiredText = post.initial.libelle &&
                post.initial.libelle.trim().length > 0 &&
                post.initial.inputText &&
                post.initial.inputText.trim().length > 0

      // Vérifier les médias
      const hasMedia = this.hasMediaContent()

      // Le bouton brouillon est activé si on a libellé + texte + média
      return !(hasRequiredText && hasMedia)
    },

    isPublishButtonDisabled () {
      const post = this.$store.getters['socialPostsCreationPostEditorial/getPost']
      const user = this.$store.getters.getUser

      // Vérifier libellé et texte
      const hasRequiredText = post.initial.libelle &&
                post.initial.libelle.trim().length > 0 &&
                post.initial.inputText &&
                post.initial.inputText.trim().length > 0

      // Vérifier les médias
      const hasMedia = this.hasMediaContent()

      // Vérifier si au moins un réseau social est sélectionné et autorisé
      const hasNetworkSelected = (
        (this.facebookChecked && user.haveFacebookEdito) ||
                (this.instagramChecked && user.haveInstagramEdito) ||
                (this.googleChecked && user.haveGMBEdito) ||
                (this.linkedInChecked && user.haveLinkedInEdito)
      )

      // Le bouton publier est activé si on a libellé + texte + média + réseau social
      return !(hasRequiredText && hasMedia && hasNetworkSelected)
    }
  },

  methods: {
    hasMediaContent () {
      // En mode édition, on ne considère que les médias dans le store (ce que l'utilisateur a actuellement)
      // Cela permet de valider que l'utilisateur a bien un média même s'il a supprimé ceux de la BDD
      const post = this.$store.getters['socialPostsCreationPostEditorial/getPost']
      const currentPost = this.$store.getters['socialPostsCreationPostEditorial/getCurrentPost']
      const isEditMode = !!(currentPost && currentPost.id)

      // 1. Vérifier les médias dans le store (ce que l'utilisateur a actuellement)
      
      // Vérifier les URLs de vidéo dans le formulaire
      const hasVideoUrlLocal = (
        (post.initial && post.initial.linkToVideo && post.initial.linkToVideo.trim() !== '') ||
                (post.facebook && post.facebook.linkToVideo && post.facebook.linkToVideo.trim() !== '') ||
                (post.google && post.google.linkToVideo && post.google.linkToVideo.trim() !== '') ||
                (post.instagram && post.instagram.linkToVideo && post.instagram.linkToVideo.trim() !== '') ||
                (post.linkedin && post.linkedin.linkToVideo && post.linkedin.linkToVideo.trim() !== '')
      )

      // Vérifier les images dans le formulaire
      const hasPhotosLocal = (
        (post.initial && post.initial.pictures && post.initial.pictures.length > 0) ||
                (post.facebook && post.facebook.pictures && post.facebook.pictures.length > 0) ||
                (post.google && post.google.pictures && post.google.pictures.length > 0) ||
                (post.instagram && post.instagram.pictures && post.instagram.pictures.length > 0) ||
                (post.linkedin && post.linkedin.pictures && post.linkedin.pictures.length > 0)
      )

      // 2. Vérifier les médias temporaires (vidéos uploadées mais pas encore sauvegardées)
      const statusMediaPost = this.$store.getters['socialPostsCreationPostEditorial/getStatusMediaPost']
      const hasTemporaryVideo = statusMediaPost && statusMediaPost.hasVideoUpload

      // En mode édition, on ne considère que les médias du store
      if (isEditMode) {
        return !!(hasVideoUrlLocal || hasPhotosLocal || hasTemporaryVideo)
      }

      // En mode création, on peut aussi considérer les médias en BDD (pour les cas de reprise)
      const fluxDest = ''
      // Photos sauvegardées en BDD
      const hasPhotosInDB = currentPost && currentPost.photos && currentPost.photos.length > 0

      // Vidéos uploadées sauvegardées en BDD
      const hasVideoUploadInDB = currentPost &&
                currentPost.assets &&
                currentPost.assets.VIDEO &&
                currentPost.assets.VIDEO[fluxDest] &&
                currentPost.assets.VIDEO[fluxDest].medias &&
                currentPost.assets.VIDEO[fluxDest].medias.length > 0

      // URLs de vidéo sauvegardées en BDD
      const hasVideoUrlInDB = currentPost &&
                currentPost.donnees &&
                currentPost.donnees.post_video_file_url_custom &&
                currentPost.donnees.post_video_file_url_custom.valeur &&
                currentPost.donnees.post_video_file_url_custom.valeur.initial &&
                currentPost.donnees.post_video_file_url_custom.valeur.initial.trim() !== ''

      return !!(hasVideoUrlLocal || hasPhotosLocal || hasPhotosInDB || hasVideoUploadInDB || hasVideoUrlInDB || hasTemporaryVideo)
    }
  }
}
